import {FormControl, FormHelperText, MenuItem, Select} from "@mui/material"
import PropTypes from "prop-types"
import React from "react"
import {getOptions} from "../../misc/widget-functions"

export const widgetChildSelecWithEnumsPrtotype = [
        {
          "key": "path",
          "type": "STRING",
          "label": "Pfad",
          "size": 6
        }
      ]

const ChildrenSelectWithEnumWidget = ({widget, value,getDataFromPointer, onValueChange, disabled}) => {
    const optionsFromPath = widget.path ? getDataFromPointer(widget.path) : []
    const enumOptions = getOptions(widget)
    const onSelectChange = event => {
        const newValue = event.target.value
        onValueChange(newValue)
    }

    const options = enumOptions.filter(({value}) => optionsFromPath.includes(value))

    return (
        <FormControl fullWidth>
            <Select
                id={widget.id}
                value={value}
                onChange={onSelectChange}
                className={widget.className}
                disabled={disabled}
            >
                {Array.isArray(options) &&
                    options.map(option => (
                        <MenuItem
                            key={option?.id}
                            value={option.value}
                            disabled={option?.disabled}
                        >
                            {option?.label}
                        </MenuItem>
                    ))}
            </Select>
            {widget.helperText && (
                <FormHelperText>{widget.helperText}</FormHelperText>
            )}
        </FormControl>
    )
}

ChildrenSelectWithEnumWidget.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
}

export default ChildrenSelectWithEnumWidget
